import { FileType } from '@lmt/shared-types';
import { StatusKey } from '@lmt/unicorn-shared/app/components/patients/profile/cases/types';
import DocIcon from '@lmt/unicorn-shared/app/icons/document-icons/doc.svg?react';
import ExcelIcon from '@lmt/unicorn-shared/app/icons/document-icons/excel.svg?react';
import ImageIcon from '@lmt/unicorn-shared/app/icons/document-icons/img.svg?react';
import DefaultIcon from '@lmt/unicorn-shared/app/icons/document-icons/no-type.svg?react';
import PdfIcon from '@lmt/unicorn-shared/app/icons/document-icons/pdf.svg?react';
import PdfIconSuccessful from '@lmt/unicorn-shared/app/icons/document-icons/pdf-successful.svg?react';
import PdfIconFailed from '@lmt/unicorn-shared/app/icons/document-icons/pdf-failed.svg?react';
import PdfIconInProcess from '@lmt/unicorn-shared/app/icons/document-icons/pdf-progress.svg?react';
import PptIcon from '@lmt/unicorn-shared/app/icons/document-icons/ppt.svg?react';
import TxtIcon from '@lmt/unicorn-shared/app/icons/document-icons/txt.svg?react';
import InternalDocumentIcon from '@lmt/unicorn-shared/app/icons/document-icons/uni-doc.svg?react';
import ZipIcon from '@lmt/unicorn-shared/app/icons/document-icons/zip.svg?react';
import React from 'react';
import styles from './DocumentIcon.module.scss';
import clsx from 'clsx';

interface Props {
  filename: string;
  fileType: FileType;
  className?: string;
  transportStatus?: StatusKey | null;
}

const PdfByStatus: React.FC<{
  status?: StatusKey | null;
  className?: string;
}> = ({ status, className }) => {
  switch (status) {
    case StatusKey.Successful:
      return (
        <PdfIconSuccessful
          data-status={StatusKey.Successful}
          className={clsx(styles.icon, className)}
        />
      );
    case StatusKey.Failed:
      return (
        <PdfIconFailed
          data-status={StatusKey.Failed}
          className={clsx(styles.icon, className)}
        />
      );
    case StatusKey.InProcess:
      return (
        <PdfIconInProcess
          data-status={StatusKey.InProcess}
          className={clsx(styles.icon, className)}
        />
      );
    default:
      return <PdfIcon className={clsx(styles.icon, className)} />;
  }
};

export const DocumentIcon: React.FC<Props> = (props) => {
  const { filename, fileType, className, transportStatus } = props;
  if (fileType === FileType.DocumentDraft) {
    return <InternalDocumentIcon className={clsx(styles.icon, className)} />;
  }
  const extension = filename.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'doc':
    case 'docx':
    case 'rtf':
      return <DocIcon className={clsx(styles.icon, className)} />;
    case 'xls':
    case 'xlsx':
      return <ExcelIcon className={clsx(styles.icon, className)} />;
    case 'pdf':
      return <PdfByStatus status={transportStatus} className={className} />;
    case 'ppt':
    case 'pptx':
      return <PptIcon className={clsx(styles.icon, className)} />;
    case 'txt':
      return <TxtIcon className={clsx(styles.icon, className)} />;
    case 'png':
    case 'jpg':
    case 'jpeg':
      return <ImageIcon className={clsx(styles.icon, className)} />;
    case 'zip':
      return <ZipIcon className={clsx(styles.icon, className)} />;
    default:
      return <DefaultIcon className={clsx(styles.icon, className)} />;
  }
};
